/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box } from '@mui/material';
import { colors } from '@farmlands/mui-theme';

export const TimelineDot: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '20px',
        left: '-20px',
        top: '20px',
        mr: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '20px',
          height: '20px',
          backgroundColor: colors.primary200,
          borderRadius: '50%',
          border: `4px solid ${colors.primary50}`,
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export const Timeline = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '10px',
        mr: '6px',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '45px',
          bottom: 25,
          left: '50%',
          width: '2px',
          backgroundColor: colors.primary200,
        }}
      />
    </Box>
  );
};

export default Timeline;
